import { useState } from 'react'

import Button from '@ilg-totallymoney/ui/components/Button'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Modal from '@ilg-totallymoney/ui/components/Modal'

import {
    CreditCardProductCategory,
    ScoredCreditCardProductsCategory,
} from '@appTypes/EligibilityApi.interface'

import useAppQueryState from '@hooks/useAppQueryState'

import { getCategoryPathForId } from '@utils/getCategoryPathForId'

import CategoryRadioButton from './components/CategoryRadioButton'

interface CategoryFilterModalProps {
    categories: ScoredCreditCardProductsCategory[]
    initialActiveCategory: CreditCardProductCategory
    onCategoryChange: (category: CreditCardProductCategory) => void
    onModalClose: () => void
    showModal: boolean
}

const CategoryFilterModal = ({
    categories,
    initialActiveCategory,
    showModal,
    onCategoryChange,
    onModalClose,
}: CategoryFilterModalProps) => {
    const [activeCategory, setActiveCategory] = useState(initialActiveCategory)
    const { goToRouteWithAppState } = useAppQueryState()

    return (
        <Modal
            isFullScreen={true}
            isOpen={showModal}
            onClose={() => {
                setActiveCategory(initialActiveCategory)
                onModalClose()
            }}
            title="Filter"
        >
            <Flex flexDirection="column" justifyContent="center">
                <Flex
                    pt="space20"
                    flexWrap="wrap"
                    justifyContent={['center', 'flex-start']}
                    mb={['space130', 'space40']}
                >
                    {categories.map(category => (
                        <CategoryRadioButton
                            isPreSelected={
                                category.id === initialActiveCategory &&
                                initialActiveCategory !== activeCategory
                            }
                            isSelected={activeCategory === category.id}
                            key={category.id}
                            category={category}
                            setActiveCategory={setActiveCategory}
                        />
                    ))}
                </Flex>
                <Flex
                    flexDirection="column"
                    mx="auto"
                    width={['100%', '343px']}
                >
                    <Button
                        variant="primary"
                        text="See results"
                        disabled={initialActiveCategory === activeCategory}
                        onClick={() => {
                            goToRouteWithAppState(
                                getCategoryPathForId(activeCategory),
                                { shallow: true }
                            )
                            onCategoryChange(activeCategory)
                            onModalClose()
                        }}
                    />
                </Flex>
            </Flex>
        </Modal>
    )
}

export default CategoryFilterModal
